import { render, staticRenderFns } from "./feedbackDetails.vue?vue&type=template&id=aa545a90&scoped=true&"
import script from "./feedbackDetails.vue?vue&type=script&lang=js&"
export * from "./feedbackDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa545a90",
  null
  
)

export default component.exports